import { FC } from 'react';

import useTicketApprovePopup from './hooks/useTicketApprovePopup';
import {
  ActionBtnStyled,
  ControlsWrapStyled,
  FlexContainerMessageStyled,
  getPopupContentStyle,
} from './TicketApprovePopup.styled';
import ErrorSection from 'components/ErrorSection/ErrorSection';
import Popup from 'components/Popup/Popup';
import SuccessSection from 'components/SuccessSection/SuccessSection';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { ScrollLockIdE } from 'declarations/enums/scroll';
import { NoopT } from 'declarations/types/common';

type TicketApprovePopupPropsT = {
  ticketId: string;
  isOpen: boolean;
  onClose: NoopT;
};

const TicketApprovePopup: FC<TicketApprovePopupPropsT> = ({ ticketId, isOpen, onClose }) => {
  const { isMobile } = useResponsive();
  const {
    isApprovingTicket,
    isTicketSuccessfullyApproved,
    isTicketApprovingError,
    showPopupContent,
    handleApproveTicket,
    handleClosePopup,
    approveTicketErrorMessage,
    approveTicketValidationErrorMessage,
  } = useTicketApprovePopup();

  return (
    <Popup
      nested
      isOpen={isOpen}
      showCloseBtn={isTicketSuccessfullyApproved || isTicketApprovingError}
      popupId={ScrollLockIdE.TicketApprovePopup}
      contentStyle={getPopupContentStyle(isMobile)}
      onClose={handleClosePopup(onClose)}
      closeOnEscape={false}
    >
      {showPopupContent && (
        <>
          <Typography color="darkBlue" variant="h2" align={isMobile ? 'center' : 'left'}>
            Are you sure you want to approve (override) the ticket?
          </Typography>
          <ControlsWrapStyled justify={isMobile ? 'center' : 'flex-end'}>
            <ActionBtnStyled
              type="button"
              variant="outline"
              size="xl"
              onClick={handleClosePopup(onClose)}
            >
              Cancel
            </ActionBtnStyled>
            <ActionBtnStyled
              variant="contained"
              size="xl"
              isLoading={isApprovingTicket}
              onClick={handleApproveTicket([ticketId])}
            >
              Approve
            </ActionBtnStyled>
          </ControlsWrapStyled>
        </>
      )}

      {isTicketSuccessfullyApproved && (
        <FlexContainerMessageStyled direction="column">
          <SuccessSection message="Ticket successfully approved" />
        </FlexContainerMessageStyled>
      )}

      {isTicketApprovingError && (
        <FlexContainerMessageStyled direction="column">
          <ErrorSection
            errorDetails={approveTicketErrorMessage || approveTicketValidationErrorMessage}
          />
        </FlexContainerMessageStyled>
      )}
    </Popup>
  );
};

export default TicketApprovePopup;
